module.exports = __webpack_public_path__ + "img/spritesheet.b330bb94.png";